import {useTranslation} from "ni18n";
import React from "react";
import {V5Img} from "src/components/_common/Carbon";

import SalesforceForm from "../Salesforce/SalesforceForm";

const Contact: React.FC = () => {
  const i18n = useTranslation();
  return (
    <div id="get-started" className="bg-lightYellow pt30 pt14-sm pb80 pb20-xs ph8 pos-r">
      <div className="maxw80 ma df fdc-md zIndex1 pos-r">
        <div className="fx df jcc mr8 mb10-md">
          <div className="maxw26">
            <h2 className="fs48 fs32-xs mb5 mb2-xs">
              {i18n.t("Reach out, and let's get started")}
            </h2>
            <p className="fs28 fs22-sm fs16-xs font-ir-xs font-cm">
              {i18n.t(
                "If you manage your students' health benefits and would like to learn more, please fill out the form, and we'll be in touch within one business day.",
              )}
            </p>
          </div>
        </div>
        <div className="fx df jcfe jcc-md">
          <div className="bs2 hfc bg-white maxw28-sm maxw32 w100p">
            <SalesforceForm
              trackingCategory="Carbon Ready"
              trackingAction="Enterprise Lead Form"
              companyFieldLabel={i18n.t("Name of school campus")}
              channel="carbon-for-campus"
            />
          </div>
        </div>
      </div>
      <V5Img
        src="/illustrations/squiggly-lines-yellow"
        className="pos-a right0 bottom0 minh40-xs minw40-xs"
      />
    </div>
  );
};

export default Contact;
